<template>
	<!--<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>-->
	<select v-model="selected" class="select2-enable" :id='`species_${line_count}`'>
	    <optgroup v-for="group in options" :label='group.text' :key='group.text'>
	      <option v-for="option in group.children" :value="option.id" :key='option.id'>
	        {{ option.name }}
	      </option>
	    </optgroup>
	 </select>
</template>

<script>
	import {DB} from './../../../constants'
	import $ from 'jquery'
	import 'select2'
	import 'select2/dist/css/select2.css'
	const SPECIES = 'get_species.php'
	//const ACT_LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'species',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: '',
			sp_id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`edit_species`, {index: this.line_count, value: this.selected})
			},
			fill () {
				this.options = this.$parent.data_location.species_list
				this.selected = this.sp_id ? this.sp_id : ''

				const data = {id: this.selected, text: this.options[1].children.find(e => {
					return e.id == this.selected
				})}

				if(data.id)
				{
					data.text = data.text.name
		            if ($('#species_' + this.$props.line_count).find("option[value='" + data.id + "']").length) {
		              $('#species_' + this.$props.line_count).val(data.id).trigger('change');
		            } else { 
		              const newOption = new Option(data.text, data.id, true, true)
		              $('#species_' + this.$props.line_count).append(newOption).trigger('change');
		            }
				}
			}
		},
		mounted: function () {
			//let region_id = this.$parent.f_12
			if(this.$parent.data_location.species_list.length)
			{
				this.fill()
			} else {
				EventBus.$on('fetch_species_complete', () => {
					this.fill()
					
					EventBus.$off('fetch_species_complete')
				})				
			}

			$(this.$el).ready(() => {
		      $('#species_' + this.$props.line_count).select2({})
		      $('#species_' + this.$props.line_count).on('change', (e) => {
		        this.$emit('input', e.target.value)
		      })
		    })

		    this.$on('input', id => {
		    	EventBus.$emit(`edit_species`, {index: this.$props.line_count, value: id})
		    })
		},
		beforeDestroy() {
			EventBus.$off('fetch_species_complete')
		}
	}
</script>

<style>
.select2-container {
  width: 100% !important;
  height: 24px !important;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	line-height: 24px;
}

.select2-container .select2-selection--single {
	height: 24px !important;
}

ul.select2-results__options {
  max-height: 410px !important;
  font-size: 12px;
}

li.select2-results__option {
  display: block;
}

.select2-selection__rendered {
	text-align: left !important;
}

.select2-container--default,
.select2-container--default .select2-selection--single {
  border: none !important;
  height: 24px;
}

.select2-dropdown {
	width: 200px !important;
}
</style>


// WEBPACK FOOTER //
// species.vue?47078f78